import Cookies from 'universal-cookie';

/**
 * Gets the locale from cookies if it exists
 */
export default function getLocale(_form) {
  return (new Cookies()).get('locale') || '';
}
